(function () {
  var STORAGE_KEY = 'branta_wishlist';

  // Stored as [{ id, handle }], not just ids, so the wishlist page can look
  // each product back up via Shopify's public /products/{handle}.js endpoint
  // without needing a Storefront API token.
  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) - fail silently.
    }
  }

  function isWishlisted(id) {
    id = String(id);
    return getItems().some(function (item) {
      return item.id === id;
    });
  }

  function toggle(id, handle) {
    id = String(id);
    var items = getItems();
    var index = items.findIndex(function (item) {
      return item.id === id;
    });

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push({ id: id, handle: handle || '' });
    }

    saveItems(items);
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { items: items } }));
    return isWishlisted(id);
  }

  function remove(id) {
    id = String(id);
    var items = getItems().filter(function (item) {
      return item.id !== id;
    });
    saveItems(items);
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { items: items } }));
  }

  function updateButtons() {
    document.querySelectorAll('.wishlist-toggle').forEach(function (btn) {
      var active = isWishlisted(btn.dataset.productId);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateCountBubble() {
    var count = getItems().length;
    document.querySelectorAll('.wishlist-count-bubble').forEach(function (el) {
      var number = el.querySelector('.wishlist-count-bubble__number');
      if (number) number.textContent = count > 0 ? count : '';
      el.classList.toggle('hidden', count === 0);
    });
  }

  function refresh() {
    updateButtons();
    updateCountBubble();
  }

  // The header bubble count only ever reflects what's in localStorage - it
  // never verifies a saved product still exists. If a product gets deleted
  // (or was saved with a blank handle before that started being stored),
  // it becomes a "ghost" entry that inflates the count everywhere except the
  // wishlist page (which already prunes these when it fetches each product).
  // Validate here too so the bubble is correct on every page, not just after
  // a visit to /pages/wishlist.
  function pruneGhosts() {
    var items = getItems();
    if (!items.length) return;

    var checks = items.map(function (item) {
      if (!item.handle) return Promise.resolve(false);
      return fetch('/products/' + item.handle + '.js')
        .then(function (response) {
          return response.ok;
        })
        .catch(function () {
          return false;
        });
    });

    Promise.all(checks).then(function (results) {
      var valid = items.filter(function (_item, index) {
        return results[index];
      });
      if (valid.length !== items.length) {
        saveItems(valid);
        document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { items: valid } }));
      }
    });
  }

  function findButtonAtPoint(event) {
    // Product cards have an invisible "click anywhere to view product" link
    // layered over the whole card, which wins hit-testing against anything
    // placed inside the card regardless of z-index (Dawn's markup nests the
    // card content in a way that isn't practical to out-stack). So event.target
    // here will almost always be that overlay link, not the button itself.
    // Instead, hit-test the click's own coordinates against any wishlist
    // button inside the same card - this works no matter what is nominally
    // on top for the browser's hit-testing.
    var direct = event.target.closest('.wishlist-toggle');
    if (direct) return direct;

    var card = event.target.closest('.card-wrapper, .product-card-wrapper');
    if (!card) return null;

    var btn = card.querySelector('.wishlist-toggle');
    if (!btn) return null;

    var rect = btn.getBoundingClientRect();
    var withinBounds =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    return withinBounds ? btn : null;
  }

  function init() {
    refresh();
    pruneGhosts();

    document.addEventListener('click', function (event) {
      var btn = findButtonAtPoint(event);
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      toggle(btn.dataset.productId, btn.dataset.productHandle);
      refresh();
    });

    document.addEventListener('wishlist:changed', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.BrantaWishlist = {
    isWishlisted: isWishlisted,
    toggle: toggle,
    remove: remove,
    getItems: getItems,
  };
})();
